import { ReadingStatus } from 'infrastructure/enums';
import { Flex } from 'antd';
import FireIcon from 'assets/img/Fire.svg?react';
import WarningCircleIcon from 'assets/img/WarningCircle.svg?react';
import CheckCircleIcon from 'assets/img/CheckCircle.svg?react';
import PolygonIcon from 'assets/img/Polygon.svg?react';

import styles from './styles.module.scss';

import type { FC } from 'react';

interface StatusIconProps {
  status: ReadingStatus;
}

const STATUS_CONFIG = {
  [ReadingStatus.Critical]: {
    Icon: FireIcon,
    bgClass: styles.critical,
  },
  [ReadingStatus.Risk]: {
    Icon: WarningCircleIcon,
    bgClass: styles.risk,
  },
  [ReadingStatus.Normal]: {
    Icon: CheckCircleIcon,
    bgClass: styles.normal,
  },
} as const;

const StatusIcon: FC<StatusIconProps> = ({ status }) => {
  const config = STATUS_CONFIG[status];

  if (!config) {
    return null;
  }

  const { Icon, bgClass } = config;

  return (
    <Flex className={styles['icon-container']}>
      <PolygonIcon className={`${styles['hexagon-bg']} ${bgClass}`} />
      <Icon className={styles.icon} />
    </Flex>
  );
};

export default StatusIcon;
